
import Vue from 'vue'
import logging from "@/logging"
// let logger = logging.getLogger("default")
// window.onerror = function (message, file, lineNo, columnNo, error) {
//     logger.error(error.stack)
//     return true
// }
// Vue.config.errorHandler = function (error, vueComponent, info) {
//     let componentName = vueComponent.$options._componentTag
//     logger.error(error.stack + "\nVue component: " + componentName + "\nVue info: " + info)
// }

import {ModalPlugin, ToastPlugin} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueCookies from 'vue-cookies'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

import './globalMethods'
// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueCookies)
// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

//for form wizard
require('@core/assets/fonts/feather/iconfont.css')

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
